const DIV = "div";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const getScrollbarWidth = (): number => {
  /*                           */
  const outer = document.body.appendChild(document.createElement(DIV));
  outer.style.visibility = "hidden";
  outer.style.overflow = "scroll"; /*                          */

  /*                                                     */
  const inner = outer.appendChild(document.createElement(DIV));

  /*                                                                        */
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  /*                                       */
  outer.parentNode!.removeChild(outer);

  return scrollbarWidth;
};
